export const colormapParsChunk = /* glsl */ `
#include <clipping_planes_pars_fragment>
uniform vec3 uColor;
`

export function colormapColorChunk(uvX: number, uvY: number, threshold: number): string {
  return /* glsl */ `
#include <map_fragment>

vec2 colormapUV = vMapUv - vec2(${uvX.toFixed(4)}, ${uvY.toFixed(4)});
float isTargetColor = step(length(colormapUV), ${threshold.toFixed(4)});
diffuseColor.rgb = mix(diffuseColor.rgb, uColor, isTargetColor);
`
}
